<template>
    <tr>
        <td><span>{{field.label}}</span></td>
        <td><input type="checkbox" v-model="add" /></td>
        <td><input type="checkbox" v-model="update" /></td>
        <td><input type="checkbox" v-model="del" /></td>
    </tr>
</template>

<script>
    export default {
        name: "FieldSettings",
        props: ['field', 'data'],

        computed: {
            add: {
                get() { return this.data.add === undefined ? true : this.data.add; },
                set(v) { this.$emit('update', this.field, 'add', v); }
            },
            update: {
                get() { return this.data.update === undefined ? true : this.data.update; },
                set(v) { this.$emit('update', this.field, 'update', v); }
            },
            del: {
                get() { return this.data.del === undefined ? true : this.data.del; },
                set(v) { this.$emit('update', this.field, 'del', v); }
            },
        },
    }
</script>